export default function Technology() {
  const techFeatures = [
    'Zero-log policy ensuring complete anonymity',
    'Kill switch protection for uninterrupted security',
    'Multi-device support across all platforms',
    'Automatic connection on untrusted networks',
  ];

  return (
    <section id="security" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="w-full h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/245409686ee891926ecfc82c4bf00218.jpg"
                alt="VPN Interface"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <span className="text-[#06B6D4] font-semibold text-sm uppercase tracking-wide">
                Advanced Technology
              </span>
            </div>

            <h3 className="text-5xl font-bold text-[#0A1F44] leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
              Built for Modern
              <br />
              Cybersecurity
            </h3>

            <p className="text-gray-600 text-lg leading-relaxed">
              Our VPN solution leverages cutting-edge encryption protocols and advanced security measures to protect your digital footprint. With servers strategically positioned worldwide, we ensure optimal performance without compromising your privacy.
            </p>

            <p className="text-gray-600 text-lg leading-relaxed">
              Experience seamless protection across all your devices with our intuitive interface designed for both personal and enterprise use.
            </p>

            <div className="space-y-4 pt-4">
              {techFeatures.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-fill text-2xl text-[#06B6D4]"></i>
                  </div>
                  <p className="text-gray-700 text-lg">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
